import React from 'react';
import { Redirect } from 'react-router-dom';

import { APICore } from '../helpers/api/apiCore';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import NotDefaultPage from '../pages/error/NotDefaultPage';
import AccessDenied from '../pages/error/AccessDenied';

const Root = () => {    
    const api = new APICore();
    const { userDetails } = useSelector((state: RootState) => ({
        userDetails: state.Auth.userDetails,
        loading: state.Auth.loading,
        error: state.Auth.error,
    }));
    const getRootUrl = () => {
        let url: string = 'auth/login';// 'landing';

        // check if user logged in or not and return url accordingly
        if (api.isUserAuthenticated() === false) {
            url = 'auth/login';//'landing';
        } else {
            //url = ``;
            url = userDetails?.defaultPage != "" ? `dashboard/dashboardPage/${userDetails?.defaultPage}` : "";

        }
        return url;
    };

    const url = getRootUrl();   
    if (url !== "")
        return <Redirect to={`/${url}`} />;
    else
        //return <AccessDenied />
    return <AccessDenied offBtnReturnToDash={false} title="شما مجوز مشاهده منوها را ندارید" />

};

export default Root;
